module.exports = __webpack_public_path__ + "img/starthouse_bodyimage03.ad7a5c96.jpg";